import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Homepage from "./components/Homepage";
import MagicShowsOrlandoPage from "./components/MagicShowsOrlandoPage";
import OrlandoDateNightPage from "./components/OrlandoDateNightPage";
import BestShowsOrlandoPage from "./components/BestShowsOrlandoPage";
import BestMagicShowOrlandoPage from "./components/BestMagicShowOrlandoPage";
import MagicShowNearMePage from "./components/MagicShowNearMePage";
import MindReaderPage from "./components/MindReaderPage";
import MentalistPage from "./components/MentalistPage";
import ArticlesPage from "./components/ArticlesPage";
import InteractiveMindGamesArticle from "./components/InteractiveMindGamesArticle";
import WhatIsMentalismArticle from "./components/WhatIsMentalismArticle";
import PerfectOrlandoDateNightArticle from "./components/PerfectOrlandoDateNightArticle";
import WhyLiveMagicArticle from "./components/WhyLiveMagicArticle";
import Top5OrlandoSummerArticle from "./components/Top5OrlandoSummerArticle";
import FirstTimersGuideArticle from "./components/FirstTimersGuideArticle";
import FAQPage from "./components/FAQPage";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/magic-shows-orlando" element={<MagicShowsOrlandoPage />} />
          <Route path="/orlando-date-night" element={<OrlandoDateNightPage />} />
          <Route path="/best-shows-orlando" element={<BestShowsOrlandoPage />} />
          <Route path="/best-magic-show-orlando" element={<BestMagicShowOrlandoPage />} />
          <Route path="/magic-show-near-me" element={<MagicShowNearMePage />} />
          <Route path="/mind-reader" element={<MindReaderPage />} />
          <Route path="/mentalist" element={<MentalistPage />} />
          <Route path="/articles" element={<ArticlesPage />} />
          <Route path="/articles/interactive-mind-games" element={<InteractiveMindGamesArticle />} />
          <Route path="/articles/what-is-mentalism" element={<WhatIsMentalismArticle />} />
          <Route path="/articles/perfect-orlando-date-night" element={<PerfectOrlandoDateNightArticle />} />
          <Route path="/articles/why-live-magic-beats-streaming" element={<WhyLiveMagicArticle />} />
          <Route path="/articles/top-5-orlando-summer" element={<Top5OrlandoSummerArticle />} />
          <Route path="/articles/first-timers-guide" element={<FirstTimersGuideArticle />} />
          <Route path="/faq" element={<FAQPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;